// export const baseUrl = 'https://localhost:44320';
export const baseUrl = 'https://scott-and-micaela.azurewebsites.net';
